import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { loadError, receive } from '../../Actions/Cart.action';
import { catchError } from '../../Actions/Error.action';
import { add as addToCartService } from '../../Services/Cart.service';
import { translate } from '../../Services/translation';
import BuyButton from '../BuyButton';
import Icon from '../IconBase/Icon';
import withReactiveStyleBuyButton from '../withReactiveStyleBuyButton';
import(`./styles/${global.ThemeName}.scss`);

const QuantityField = ({
  quantityFieldId,
  packSize = 1,
  handleQuantityInput,
  type,
  articleNumber,
  orderQuantity,
}) => {
  const quantityFieldRef = useRef(null);
  const [quantity, setQuantity] = useState(
    orderQuantity ? orderQuantity : packSize
  );
  const [editorQuantity, setEditorQuantity] = useState(
    orderQuantity ? orderQuantity : quantity
  );
  const [inputEditing, setInputEditing] = useState(false);
  const canDecrease = quantity > packSize;
  const singlePack = packSize === 1;
  const packedQuantity = quantity / packSize;

  const onQuantityDisplayClick = (e) => {
    setInputEditing(true);
    if (quantityFieldRef !== null && quantityFieldRef.current) {
      quantityFieldRef.current.focus();
      quantityFieldRef.current.select();
    }
  };
  const changeQuantity = (editorQuantity) => {
    const calculatedQuantity = Math.ceil(editorQuantity / packSize);
    const packedQuantity = calculatedQuantity <= 1 ? 1 : calculatedQuantity;

    setInputEditing(false);
    setQuantity(packedQuantity * packSize);
    setEditorQuantity(packedQuantity * packSize);
    if (type == 'checkout') {
      handleQuantityInput(
        articleNumber,
        packedQuantity * packSize,
        quantityFieldId
      );
    }
  };
  const onBlur = (e) => changeQuantity(e.target.value);
  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      changeQuantity(e.target.value);
    }
  };
  const onChange = (e) => {
    if (type == 'checkout') {
      handleQuantityInput(articleNumber, quantity, quantityFieldId);
    }
    setEditorQuantity(e.target.value);
  };
  const onDecrease = () => {
    const newQuantity = quantity <= packSize ? quantity : quantity - packSize;
    setQuantity(newQuantity);
    setEditorQuantity(newQuantity);
    if (type == 'checkout') {
      handleQuantityInput(articleNumber, newQuantity, quantityFieldId);
    }
  };
  const onIncrease = () => {
    const newQuantity = quantity + packSize;
    setQuantity(newQuantity);
    setEditorQuantity(newQuantity);
    if (type == 'checkout') {
      handleQuantityInput(articleNumber, newQuantity, quantityFieldId);
    }
  };

  useEffect(() => {
    const quantityDiff = quantity % packSize;
    if (quantityDiff !== 0) {
      const newQuantity = quantity - quantityDiff;
      if (newQuantity < packSize) {
        setQuantity(packSize);
      } else {
        setQuantity(newQuantity);
      }
    }
  }, [packSize]);

  return (
    <div
      className={`buy-button-pack__quantity ${
        inputEditing ? 'buy-button-pack__quantity--input-editing' : ''
      }`}
    >
      <input
        id={quantityFieldId}
        type="number"
        data-buy-quantity-input
        value={quantity}
        min={0}
        max={999}
        maxLength={3}
        className="buy-button-pack__hidden-quantity-field"
        readOnly
      />
      <div className="buy-button-pack__quantity-navigation-container">
        <Icon
          iconClass={`buy-button-pack__quantity-button ${
            canDecrease ? '' : 'buy-button-pack__quantity-button--disabled'
          }`}
          iconCode="remove"
          onClick={onDecrease}
        />
        <div
          className="buy-button-pack__quantity-display"
          onClick={onQuantityDisplayClick}
        >
          {singlePack ? (
            <span className="buy-button-pack__quantity-display__single_pack">
              {quantity}
            </span>
          ) : (
            <>
              <span className="buy-button-pack__quantity-display__total">
                {quantity} {translate('general.totalunit')}
              </span>
              <span className="buy-button-pack__quantity-display__quantity">
                {packedQuantity} {translate('general.packunit')}
              </span>
            </>
          )}
        </div>
        <div className="buy-button-pack__quantity-editor">
          <input
            type="number"
            defaultValue={editorQuantity}
            value={editorQuantity}
            min={0}
            className="buy-button-pack__quantity-field form__input"
            onChange={onChange}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            ref={quantityFieldRef}
          />
        </div>
        <Icon
          iconClass={'buy-button-pack__quantity-button'}
          iconCode="add"
          onClick={onIncrease}
        />
      </div>
    </div>
  );
};

const BuyButtonPack = (props) => {
  const {
    articleNumber,
    quantityFieldId,
    href,
    cssClass,
    label,
    packSize,
    type = 'default',
    handleQuantityInput,
    orderQuantity,
  } = props;
  const dispatch = useDispatch();
  const onClick = async ({ articleNumber, quantityFieldId }) => {
    if (window.fbq != undefined) {
      fbq('track', 'AddToCart', {
        content_ids: [articleNumber],
      });
    }

    try {
      const quantity = quantityFieldId
        ? document.getElementById(quantityFieldId).value
        : 1;
      const cart = await addToCartService({ articleNumber, quantity });
      dispatch(receive(cart));
      return true;
    } catch (ex) {
      dispatch(catchError(ex, (error) => loadError(error)));
      return false;
    }
  };
  const Button = withReactiveStyleBuyButton(
    BuyButton,
    onClick,
    'buy-button-pack'
  );

  return (
    <div className={`buy-button-pack buy-button-pack--${type}`}>
      <QuantityField
        {...{
          quantityFieldId,
          packSize,
          handleQuantityInput,
          type,
          articleNumber,
          orderQuantity,
        }}
      />
      {type != 'checkout' && <Button {...props} fluid={true} />}
    </div>
  );
};

export default BuyButtonPack;
